

















































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import { BUTTON } from '@/constants/label';
import { UmuFlg, OutStatus } from '@/constants/constants';
import moment from 'moment';
import Vue from 'vue';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlAttachment',
  components: {
    VuePdfEmbed,
    CtrlNormalBtn,
    CtrlMessageDialog,
  },
  props: {
    attachmentFlag: {
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    tempEntryYmd: {
      type: Number,
      default: 0,
    },
    tempSeq: {
      type: Number,
      default: 0,
    },
    tempMukoFlg: {
      type: Number,
      default: 0,
    },
    attachedData: {
      type: String,
      default: '',
    },
    attachmentTime: {
      type: String,
      default: '',
    },
    downloadFileName: {
      type: String,
      default: '',
    },
    callbackOk: {
      type: Function,
    },
    callbackNg: {
      type: Function,
    },
  },
  data: () => ({
    BUTTON,
    UmuFlg,
    showPreviewPDF: false,
    showMessage: false,
    messageId: '',
    messageTextParam: [],
    tempShiryo: '',
  }),
  computed: {
    ...mapGetters({
      headerInfo: 'common/headerInfo',
    }),
    fileAttachmentRef() {
      return this.$refs.fileAttachmentRef;
    },
  },
  methods: {
    // 追加
    handleFileAttachment(event: any) {
      if (event.target.files.length > 0) {
        // 拡張子チェック
        if (event.target.files[0].type !== 'application/pdf') {
          // PDF以外はエラー
          this.showMessage = true;
          this.messageId = 'KI_W119';
          return;
        }
        
        // ファイルサイズチェック
        const fileSize = event.target.files[0].size;
        // MB単位取得
        const fileSizeMB = fileSize/1024**2;
        // ファイルサイズ上限値
        const limitSize = process.env.VUE_APP_ADD_FILE_LIMIT_SIZE_MB;
        if (limitSize) {
          if(fileSizeMB > limitSize){
            // 上限オーバーはエラー
            this.showMessage = true;
            this.messageId = 'KI_W123';
            this.messageTextParam = ['ファイルサイズが' + limitSize + 'MBを超える', '追加'];
            return;
          }
        }

        const file = event.target.files[0];
        this.getBase64(file).then((data: any) => {
          const fileData = {
            tempData: data,
            tempDate: moment(new Date()).format('YYYY-MM-DD HH:mm'),
            tempUmuFlg: UmuFlg.ARI,
          };
          this.callbackOk && this.callbackOk(fileData);
        });
      }
    },
    // 削除
    handleDeleteFile() {
      this.fileAttachmentRef.value = null;
      const fileData = {
        tempData: '',
        tempDate: '',
        tempUmuFlg: UmuFlg.NASHI,
      };
      this.callbackOk && this.callbackOk(fileData);
    },
    //PDF to base64
    getBase64(file: any) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    // PDF出力
    handlePdfOut() {
      const linkSource = this.tempShiryo;
      const downloadLink = document.createElement("a");
      let fileName = '';

      if (!this.downloadFileName) {
        if (!this.headerInfo.title) {
          fileName = '別紙添付';
        } else {
          fileName = this.headerInfo.title;
        }
        let sysDateTime = this.attachmentTime;
        sysDateTime = sysDateTime.replaceAll('-', '');
        sysDateTime = sysDateTime.replaceAll(':', '');
        sysDateTime = sysDateTime.replaceAll(' ', '_');

        fileName = fileName + '_' + sysDateTime + '.pdf';
      } else {
        fileName = this.downloadFileName;
      }
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
    // 参照
    getAttachedData() {
      this.$store.dispatch('common/setIsLoading', true);
      if (this.attachedData || this.tempShiryo) {
        this.tempShiryo = this.attachedData ? this.attachedData : this.tempShiryo;
        this.showPreviewPDF = true;
        this.$store.dispatch('common/setIsLoading', false);
    } else {
        //別紙添付データ取得
        const params = {
          tempEntryYmd: this.tempEntryYmd,
          tempSeq: this.tempSeq,
          tempMukoFlg: this.tempMukoFlg
        };

        this.$store.dispatch(
          'common/getBesshiTemp',
          params
        ).then((res: any) => {
          if (
            res &&
            res.status == 200 &&
            res.data &&
            res.data.error &&
            res.data.error.outStatus &&
            res.data.error.outStatus != OutStatus.NORMAL
          ) {
            const { error } = res.data;
            this.showMessage = true;
            this.messageId = error.messageID;
            this.messageTextParam = error.messageArgs;
            this.$store.dispatch('common/setIsLoading', false);
            return;
          }
          if (!res.data.responseData) {
            this.callbackNg && this.callbackNg('KI_W124');
            this.$store.dispatch('common/setIsLoading', false);
            return;
          }
          this.tempShiryo = res.data.responseData.tempShiryo;
          this.showPreviewPDF = true;    
          this.$store.dispatch('common/setIsLoading', false);
        });
      }
    },
    // ワーニングOK
    async handleMessageOk() {
      this.showMessage = false;
      this.handleDeleteFile();
    },
  },
});
